import { ProfessionalService } from "../../types";

interface Props {
  approvable: ProfessionalService[];
  unapprovable: ProfessionalService[];
}

const ACTIVATION_COPY =
  "will be available in the project editor for consumption and will be moved to the active tab.";

/**
 * Body of the Approve modal on the pending services tab.
 *
 * When the user approves everything they selected this is the plain
 * confirmation it has always been. When some or none of the selection belongs
 * to a line of business they approve for, it names both groups instead - the
 * page used to offer Approve on every pending service and let the API refuse
 * it with an unexplained toast.
 */
const ApproveModalBody = ({ approvable, unapprovable }: Props) => {
  const total = approvable.length + unapprovable.length;

  if (!unapprovable.length) {
    return (
      <div className="modalBody">
        <p>
          <strong>{`You are about to approve ${total} service${
            total === 1 ? "" : "s"
          }.`}</strong>
        </p>
        <p>{`${
          total === 1 ? "This service" : "These services"
        } ${ACTIVATION_COPY}`}</p>
      </div>
    );
  }

  return (
    <div className="modalBody approveModalBody">
      <p>
        <strong>
          {approvable.length
            ? `${approvable.length} of ${total} selected services can be approved.`
            : `None of the ${total} selected services can be approved.`}
        </strong>
      </p>
      {approvable.length > 0 && (
        <div className="approvableGroup">
          <p className="groupHeading">Can be approved</p>
          <ul>
            {approvable.map((service) => (
              <li key={service.id}>{service.attributes.name}</li>
            ))}
          </ul>
        </div>
      )}
      <div className="unapprovableGroup">
        <p className="groupHeading">Cannot be approved</p>
        <ul>
          {unapprovable.map((service) => (
            <li key={service.id}>{service.attributes.name}</li>
          ))}
        </ul>
        <p className="groupReason">
          You are not a service approver for this line of business.
        </p>
      </div>
    </div>
  );
};

export default ApproveModalBody;
